import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initHorizontalScroll() {
  const cardsWrapper = document.querySelector(".cards-wrapper");
  const cardsContainer = document.querySelector(".cards");
  const scrollSection = document.querySelector(".scroll-section");

  if (!cardsWrapper || !cardsContainer || !scrollSection) {
    return null;
  }

  // Sprawdzamy czy są karty do przewijania
  if (cardsContainer.children.length === 0) {
    console.warn("Kontener kart jest pusty");
    return null;
  }

  const totalWidth = cardsContainer.scrollWidth;
  const moveX = totalWidth - cardsWrapper.offsetWidth;

  if (moveX <= 0) {
    console.warn("Karty mieszczą się w kontenerze - brak potrzeby przewijania poziomego");
    return null;
  }

  return gsap.to(cardsContainer, {
    x: -moveX,
    ease: "none",
    scrollTrigger: {
      trigger: scrollSection,
      start: "top top",
      end: () => `+=${moveX}`,
      scrub: true,
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      markers: false // ustaw na true dla debugowania
    }
  });
}

const animation = initHorizontalScroll();
